// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2WisF","rootSmall":"AddTileButton_rootSmall__1fMaO"};